// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit :NANDHAKUMAR
// Last ADD : LAST EMI DETAILS SAGA CREATED
// MODIFIED DATE: 16-09-2025

import { call, put, takeLatest, all } from 'redux-saga/effects';
import LastEMIDetailsActionTypes from './last-emi-details.types';
import {
	getLastEMIDetailsSuccess,
	getLastEMIDetailsFailure,
	getLastEMIDetailsResponseChanged,
} from './last-emi-details.action';
import { getLastEMIDetails } from './last-emi-details.service';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** ********************* GET LAST EMI DETAILS START ******************** */
export function* getLastEMIDetailsSaga({ payload }: any) {
	try {
		const {
			companyID,
			userID,
			branchID,
			databaseName,
			fromDate,
			toDate,
			loanIndexType,
			limit,
		} = payload;
		const key = 'GetLastEMIDetailsRecordKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			BranchID: branchID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			LoanIndexType: loanIndexType,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getLastEMIDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLastEMIDetailsFailure(responseData.data));
		} else {
			yield put(getLastEMIDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLastEMIDetailsFailure(error));
	}
}

export function* resetLastEMIDetailsResponse() {
	yield put(getLastEMIDetailsResponseChanged());
}

export function* onGetLastEMIDetails() {
	yield takeLatest(LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_START, getLastEMIDetailsSaga);
}

export function* onGetLastEMIDetailsResponseReset() {
	yield takeLatest(
		LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_RESPONSE_RESET,
		resetLastEMIDetailsResponse,
	);
}
/** ********************* GET LAST EMI DETAILS END ******************** */

export function* LastEMIDetailsSaga() {
	yield all([call(onGetLastEMIDetails), call(onGetLastEMIDetailsResponseReset)]);
}
